import { create } from "zustand";

export const createCartSlice = create((set) => ({
  cart: [],
  addToCart: (product) =>
    set((state) => {
      const existingProduct = state.cart.find((p) => p.id === product.id);

      if (existingProduct) {
        return {
          cart: state.cart.map((p) =>
            p.id === product.id 
              ? { ...p, quantity: (p.quantity || 0) + 1 } 
              : p
          ),
        };
      }
      return { 
        cart: [...state.cart, { ...product, quantity: 1 }] 
      };
    }),

  removeFromCart: (productId) =>
    set((state) => {
      return {
        cart: state.cart.filter((product) => product._id !== productId),
      };
    }),
  clearCart: () => set({ cart: [] }),
}))

export const useCartStore = createCartSlice;

